import {
  submitExamResult,
  getExamList,
  examNumber,
  statusInfo,
  finishOnlineLearn,
  cancelAppointment,
  appointmentAgain,
  applyNoPassReason,
  rateCityManager,
  courseOffline,
  getTrainInfo,
  getSupplierInfo,
  appointmentSuccess,
  queryOnlineLearnInfo,
  checkLogoff,
  onlineAgain,
  applyNoPassOnlineReason
} from '@/pages/services/recruit'
import { examData } from '@/pages/dataMidderware/recruitExam'
import { openRecruit } from '@/utils/appAgreement'
import toast from '@flashex-fe-comp/issdesign/lib/toast'
const back = (data: any) => {
  if (!!data.data && data.data.status === 500) {
    toast(data.data.err)
    setTimeout(() => {
      openRecruit()
    }, 1000)
  }
}
export default {
  namespace: 'recruit',

  state: {
    examList: [],
    status: {},
    examNumber: 0,
    examInfo: { totalExamCount: 5, reaminExamCount: 5 }
  },

  subscriptions: {
    setup () {
      // eslint-disable-line
    }
  },

  effects: {
    // 查询考试题
    * getExamList ({ payload: value }, { call, put, select }) {
      // eslint-disable-line
      try {
        const { data } = yield call(getExamList, value)
        // const tempList = yield select((state: any) => state.recruit.examList)
        // let examList = [...tempList, ...data.data]
        // 此处清洗数据
        const examList = examData(data.data || [])
        yield put({ type: 'EXAM_LIST', payload: { examList } })
        return examList
      } catch (error) {
        back(error)
        console.log(error)
      }
    },
    // 提交考试结果
    * submitExamResult ({ payload: value }, { call }) {
      // eslint-disable-line
      try {
        const { data } = yield call(submitExamResult, value)
        const examResult = { ...data.data }
        return examResult
      } catch (error) {
        back(error)
        console.log(error)
      }
    },
    // 查询闪送员状态
    * getStatusInfo ({ payload: value }, { call, put, select }) {
      // eslint-disable-line
      try {
        const { data } = yield call(statusInfo, value)
        const tempList = yield select((state: any) => state.recruit.status)
        const status = { ...tempList, ...data.data }
        // 此处清洗数据
        yield put({ type: 'STATUS_INFO', payload: { status } })
        return status
      } catch (error) {
        back(error)
        console.log(error)
      }
    },
    // 获取考试次数
    * getExamNumber ({ payload: value }, { call, put, select }) {
      // eslint-disable-line
      try {
        const { data } = yield call(examNumber, value)
        const tempList = yield select((state: any) => state.recruit.examInfo)
        const examInfo = { ...tempList, ...data.data }
        // 此处清洗数据
        yield put({ type: 'EXAM_NUMBER', payload: { examInfo } })
        return examInfo
      } catch (error) {
        back(error)
        console.log(error)
      }
    },
    // 完成招募在线学习课程
    * finishOnlineLearn ({ payload: value }, { call }) {
      // eslint-disable-line
      try {
        const { data } = yield call(finishOnlineLearn, value)
        const result = { ...data.data }
        // 此处清洗数据
        return result
      } catch (error) {
        back(error)
        console.log(error)
      }
    },
    // 取消预约
    * cancelAppointment ({ payload: value }, { call }) {
      // eslint-disable-line
      try {
        const { data } = yield call(cancelAppointment, value)
        const result = { ...data.data }
        // 此处清洗数据
        return result
      } catch (error) {
        back(error)
        console.log(error)
      }
    },
    // 重新预约
    * appointmentAgain ({ payload: value }, { call }) {
      // eslint-disable-line
      try {
        const { data } = yield call(appointmentAgain, value)
        const result = { ...data.data }
        // 此处清洗数据
        return result
      } catch (error) {
        back(error)
        console.log(error)
      }
    },
    // 申请审核不通过原因
    * applyNoPassReason ({ payload: value }, { call }) {
      // eslint-disable-line
      try {
        const { data } = yield call(applyNoPassReason, value)
        const result = data.data
        // 此处清洗数据
        return result
      } catch (error) {
        back(error)
        console.log(error)
      }
    },
    // 提交评价师评价
    * rateCityManager ({ payload: value }, { call }) {
      // eslint-disable-line
      try {
        const { data } = yield call(rateCityManager, value)
        return data
      } catch (error) {
        back(error)
        console.log(error)
      }
    },
    // 课程活陪许下线时上报后台
    * courseOffline ({ payload: value }, { call }) {
      // eslint-disable-line
      try {
        const { data } = yield call(courseOffline, value)
        const result = { ...data.data }
        // 此处清洗数据
        return result
      } catch (error) {
        back(error)
        console.log(error)
      }
    },
    // 培训站点信息
    * getTrainInfo ({ payload: value }, { call }) {
      // eslint-disable-line
      try {
        const { data } = yield call(getTrainInfo, value)
        const result = { ...data.data }
        // 此处清洗数据
        return result
      } catch (error) {
        back(error)
        console.log(error)
      }
    },
    // 获取闪送员供应商信息
    * getSupplierInfo ({ payload: value }, { call }) {
      // eslint-disable-line
      try {
        const { data } = yield call(getSupplierInfo, value)
        const result = { ...data.data }
        // 此处清洗数据
        return result
      } catch (error) {
        back(error)
        console.log(error)
      }
    },
    // 预约成功文案
    * appointmentSuccess ({ payload: value }, { call }) {
      // eslint-disable-line
      try {
        const { data } = yield call(appointmentSuccess, value)
        const result = { ...data.data }
        // 此处清洗数据
        return result
      } catch (error) {
        back(error)
        console.log(error)
      }
    },
    // 查询闪送员在线培训信息
    * queryOnlineLearnInfo ({ payload: value }, { call }) {
      // eslint-disable-line
      try {
        const { data } = yield call(queryOnlineLearnInfo, value)
        const result = { ...data.data }
        // 此处清洗数据
        return result
      } catch (error) {
        back(error)
        console.log(error)
      }
    },
    // 查询注销状态
    * checkLogoff ({ payload: value }, { call }) {
      try {
        const { data } = yield call(checkLogoff, value)
        return data
      } catch (error) {
        back(error)
        console.log(error)
      }
    },
    // 线上申请审核不通过原因
    * applyNoPassOnlineReason ({ payload: value }, { call }) {
      try {
        const { data } = yield call(applyNoPassOnlineReason, value)
        return data
      } catch (error) {
        back(error)
        console.log(error)
      }
    },
    // 线上招募 重新认证
    * onlineAgain ({ payload: value }, { call }) {
      try {
        const { data } = yield call(onlineAgain, value)
        return data
      } catch (error) {
        back(error)
        console.log(error)
      }
    }
  },

  reducers: {
    EXAM_LIST (state: any, { payload: { examList } }) {
      return { ...state, examList }
    },
    STATUS_INFO (state: any, { payload: { status } }) {
      return { ...state, status }
    },
    EXAM_NUMBER (state: any, { payload: { examInfo } }) {
      return { ...state, examInfo }
    }
  }
}
